import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon, faCircleHalfStroke } from '@fortawesome/free-solid-svg-icons';
import './ThemeToggle.css';

function ThemeToggle() {
  const [theme, setTheme] = useState('auto');

  useEffect(() => {
    // Load saved theme from localStorage
    const savedTheme = localStorage.getItem('theme') || 'auto';
    setTheme(savedTheme);
    applyTheme(savedTheme);
  }, []);

  const applyTheme = (selectedTheme) => {
    let actualTheme = selectedTheme;

    if (selectedTheme === 'auto') {
      // Check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      actualTheme = prefersDark ? 'dark' : 'light';
    }

    document.documentElement.setAttribute('data-theme', actualTheme);
  };

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
    applyTheme(newTheme);
  };

  return (
    <div className="theme-toggle">
      <button
        className={`theme-btn ${theme === 'light' ? 'active' : ''}`}
        onClick={() => handleThemeChange('light')}
        title="Light Mode"
      >
        <FontAwesomeIcon icon={faSun} />
      </button>
      <button
        className={`theme-btn ${theme === 'auto' ? 'active' : ''}`}
        onClick={() => handleThemeChange('auto')}
        title="Auto (ตามระบบ)"
      >
        <FontAwesomeIcon icon={faCircleHalfStroke} />
      </button>
      <button
        className={`theme-btn ${theme === 'dark' ? 'active' : ''}`}
        onClick={() => handleThemeChange('dark')}
        title="Dark Mode"
      >
        <FontAwesomeIcon icon={faMoon} />
      </button>
    </div>
  );
}

export default ThemeToggle;
